import { memo, type ReactNode } from 'react';
import clsx from 'clsx';

import styles from './styles/main.module.css';

interface Props {
	children: ReactNode;
	className?: string;
}

export default memo(Main);

function Main({ children, className }: Props) {
	return <main className={clsx(styles['main'], className)}>{children}</main>;
}
